import { StateStore } from "../Store/StateStore";
import { PageStatusFlags } from "../ComponentDataModels/IPageStatus";
import { FlagUtility } from "../Utility/FlagUtility";

export class Reducers {
    public static loginComplete(state: StateStore): StateStore {
        return { ...state, pageStatus: FlagUtility.clearFlag(state.pageStatus, PageStatusFlags.LoggingIn) };
    }

    public static loginFailed(state: StateStore, message: string): StateStore {
        return { ...state, pageMessage: message, pageStatus: FlagUtility.clearFlag(state.pageStatus, PageStatusFlags.LoggingIn) };
    }

    public static getWebChatTokenCompleted(state: StateStore, webChatToken: string): StateStore {
        return { ...state, webChatToken: webChatToken, pageStatus: FlagUtility.clearFlag(state.pageStatus, PageStatusFlags.WaitingForWebChatToken) };
    }

    public static getWebChatTokenFailed(state: StateStore, message: string): StateStore {
        return { ...state, pageMessage: message, pageStatus: FlagUtility.clearFlag(state.pageStatus, PageStatusFlags.WaitingForWebChatToken) };
    }

    public static clearWebChatTokenAndUpdateState(state: StateStore): StateStore {
        return { ...state, webChatToken: undefined, pageStatus: FlagUtility.setFlag(state.pageStatus, PageStatusFlags.WaitingForWebChatToken) };
    }

    public static onBotEndpointReady(state: StateStore) {
        return { ...state, pageStatus: FlagUtility.clearFlag(state.pageStatus, PageStatusFlags.WaitingForBotReady) };
    }

    public static onBotEndpointNotReady(state: StateStore) {
        return { ...state, pageStatus: FlagUtility.setFlag(state.pageStatus, PageStatusFlags.WaitingForBotReady) };
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Reducers/Reducers.tsx